import { E_UserStatus } from './types';
export var E_UserInfoCreatedFrom;
(function (E_UserInfoCreatedFrom) {
    /**
     * 自主注册
     */
    E_UserInfoCreatedFrom["SELF_REGISTER"] = "Self-registration";
    /**
     * 产品导流Product Guidance
     */
    E_UserInfoCreatedFrom["PRODUCT_GUIDANCE"] = "Product Guidance";
    /**
     * 管理员添加From Admin
     */
    E_UserInfoCreatedFrom["FROM_ADMIN"] = "From Admin";
    /**
     * 自注册链接Self-registration Link
     */
    E_UserInfoCreatedFrom["SELF_REGISTER_LINK"] = "Self-registration Link";
    /**
     * BO创建From BO
     */
    E_UserInfoCreatedFrom["FROM_BO"] = "From BO";
    /**
     * 市场活动 Campaign
     */
    E_UserInfoCreatedFrom["CAMPAIGN"] = "Campaign";
    /**
     * 官网 Official Website
     */
    E_UserInfoCreatedFrom["OFFICIAL_WEBSITE"] = "Official Website";
    /**
     * SSO
     */
    E_UserInfoCreatedFrom["SSO"] = "SSO";
})(E_UserInfoCreatedFrom || (E_UserInfoCreatedFrom = {}));
export var E_PermissionHttpMethod;
(function (E_PermissionHttpMethod) {
    E_PermissionHttpMethod["GET"] = "GET";
    E_PermissionHttpMethod["DELETE"] = "DELETE";
    E_PermissionHttpMethod["PUT"] = "PUT";
    E_PermissionHttpMethod["POST"] = "POST";
    E_PermissionHttpMethod["PATCH"] = "PATCH";
})(E_PermissionHttpMethod || (E_PermissionHttpMethod = {}));
/**
 * 用户状态 新版
 */
export var E_ACCOUNT_STATUS;
(function (E_ACCOUNT_STATUS) {
    /**
     * 返回用户状态不为Block，并且last_login不为空的用户
     */
    E_ACCOUNT_STATUS[E_ACCOUNT_STATUS["ACTIVE"] = E_UserStatus.ACTIVE] = "ACTIVE";
    /**
     * 待激活，返回用户状态不为Block，并且last_login为空的用户
     */
    E_ACCOUNT_STATUS[E_ACCOUNT_STATUS["PENDING"] = E_UserStatus.PENDING] = "PENDING";
    /**
     * 禁用
     */
    E_ACCOUNT_STATUS[E_ACCOUNT_STATUS["BLOCKED"] = E_UserStatus.BLOCKED] = "BLOCKED";
})(E_ACCOUNT_STATUS || (E_ACCOUNT_STATUS = {}));
(function (E_ACCOUNT_STATUS) {
    /**
     * 显示禁用
     */
    function canUseBlock(value) {
        return ![E_ACCOUNT_STATUS.BLOCKED].includes(value);
    }
    E_ACCOUNT_STATUS.canUseBlock = canUseBlock;
    /**
     * 显示解禁
     */
    function canUseUnblock(value) {
        return [E_ACCOUNT_STATUS.BLOCKED].includes(value);
    }
    E_ACCOUNT_STATUS.canUseUnblock = canUseUnblock;
})(E_ACCOUNT_STATUS || (E_ACCOUNT_STATUS = {}));
export var E_SALES_BELONG;
(function (E_SALES_BELONG) {
    /**
     * 自己名下的
     */
    E_SALES_BELONG[E_SALES_BELONG["YES"] = 1] = "YES";
    /**
     * 非自己名下
     */
    E_SALES_BELONG[E_SALES_BELONG["NO"] = 0] = "NO";
})(E_SALES_BELONG || (E_SALES_BELONG = {}));
export var EPrivilegeLimitationWay;
(function (EPrivilegeLimitationWay) {
    EPrivilegeLimitationWay["unlimited"] = "Unlimited";
    EPrivilegeLimitationWay["ip"] = "IP Range";
    EPrivilegeLimitationWay["domain"] = "Domains";
    EPrivilegeLimitationWay["sso"] = "SSO";
})(EPrivilegeLimitationWay || (EPrivilegeLimitationWay = {}));
